import { render } from "./Prospect.vue?vue&type=template&id=8a4b4690"
import script from "./Prospect.vue?vue&type=script&lang=js"
export * from "./Prospect.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__